import { render, staticRenderFns } from "./LegalEntityInfo.vue?vue&type=template&id=860967ac&scoped=true"
import script from "./LegalEntityInfo.vue?vue&type=script&lang=js"
export * from "./LegalEntityInfo.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityInfo.vue?vue&type=style&index=0&id=860967ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860967ac",
  null
  
)

export default component.exports